import { Component, OnInit } from '@angular/core';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { StpRegistrationStorageService } from '../../../services/stp-registration-storage.service';

@Component({
  selector: 'app-sent-for-corrections-list',
  templateUrl: './sent-for-corrections-list.component.html',
})
export class SentForCorrectionsListComponent implements OnInit {

  total: number = 0;
  size: number = 10;
  page: number = 1;
  sortingKey: string | undefined;
  sortingValue: string | undefined;
  sentForCorrectionsList: any[] = [];
  userInfo: any;

  constructor(
    private stpRegistrationStorageService: StpRegistrationStorageService,
  ) {}

  ngOnInit(): void {
    this.userInfo = JSON.parse(localStorage.getItem('currentUserInfo') || '{}');
  }

  getSubmittedStpCorrectionRequestListByUserId(): void {
    this.stpRegistrationStorageService
      .getSubmittedStpCorrectionRequestListByUserId(
        this.page,
        this.size,
        this.sortingKey,
        this.sortingValue,
        this.userInfo?.id
      )
      .subscribe({
        next: (res) => {
          this.sentForCorrectionsList = res?.data ?? [];
          this.total = res?.count ?? 0;
        },
      });
  }

  getStatusLabel(data: any): string {
    if (data?.approvalStatusId === 1) {
      return 'Approved';
    }

    if (data?.approvalStatusId === 2) {
      return 'Rejected';
    }

    return 'Pending';
  }

  getStatusClass(data: any): string {
    if (data?.approvalStatusId === 1) {
      return 'badge badge-success';
    }

    if (data?.approvalStatusId === 2) {
      return 'badge badge-danger';
    }

    return 'badge badge-primary';
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    this.page = params.pageIndex;
    this.size = params.pageSize;
    this.sortingKey = undefined;
    this.sortingValue = undefined;

    params.sort.forEach((element) => {
      if (element.value != null) {
        this.sortingKey = element.key;
        this.sortingValue = element.value;
      }
    });

    this.getSubmittedStpCorrectionRequestListByUserId();
  }
}
